module.exports = __webpack_public_path__ + "img/square-sliders-vertical.57ca53a9.svg";